import { HttpClient } from "@angular/common/http";
import { SCAMP_API, SCAMP_API_RPT } from "src/environments/environment";
import { AccountService } from "./account.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class SpvService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    save(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/spv`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    /*  editar(id: number, data) {
          return this.http.put(`${SCAMP_API.accountApiV1}/spv/${id}`, data, {headers : this.account.composeHeaders()});
      } */
    /* getSpvsDetalhes(): Observable<SpvDetalhes[]> {
          return this.http.get<SpvDetalhes[]>(`${SCAMP_API.accountApiV1}/spvs/detalhes`, {headers : this.account.composeHeaders()});
      } */
    getSpvsAbertosPorUsuario() {
        return this.http.get(`${SCAMP_API.accountApiV1}/spvs-abertos-do-usuario`, { headers: this.account.composeHeaders() });
    }
    getSpvsAbertos() {
        return this.http.get(`${SCAMP_API.accountApiV1}/spvs-abertos`, { headers: this.account.composeHeaders() });
    }
    getSpvsAbertosQtd() {
        return this.http.get(`${SCAMP_API.accountApiV1}/spvs-abertos-qtd`, {
            headers: this.account.composeHeaders(),
        });
    }
    getSpvsParaQualificar(filtroAreaTecnicaId, empreiteiraId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/spvs-para-qualificar/${filtroAreaTecnicaId}/${empreiteiraId}`, { headers: this.account.composeHeaders() });
    }
    getSpvsParaQualificarMarcados(spvIds) {
        return this.http.post(`${SCAMP_API.accountApiV1}/spvs-para-qualificar/marcados`, { spvIds: spvIds }, { headers: this.account.composeHeaders() });
    }
    getSpvDetalhes(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/spv-detalhes/${id}`, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/spv/${id}`, {
            headers: this.account.composeHeaders(),
        });
    }
    getSpvAprovadoParaQualificar(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/spv-para-qualificar/${id}`, { headers: this.account.composeHeaders() });
    }
    aprovarSpv(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/spv-aprovar`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    getStatusSS(spvId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/ss/getstatus/${spvId}`, { headers: this.account.composeHeaders() });
    }
    setIrregulariadeSpv(spvId, irregularidadeId) {
        return this.http.post(`${SCAMP_API.accountApiV1}/spv/irregularidade/${spvId}/${irregularidadeId}`, null, { headers: this.account.composeHeaders() });
    }
    recusarSpv(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/spv-recusar`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    qualificarSpv(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/spv-qualificar`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    getSSsPorPeriodo(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/ss/por-periodo`, data, { headers: this.account.composeHeaders() });
    }
    getSpvCompleto(id, tipoSpv) {
        if (tipoSpv === 1) {
            return this.http.get(`${SCAMP_API.accountApiV1}/spv-completo/${id}`);
        }
        if (tipoSpv === 2) {
            return this.http.get(`${SCAMP_API.accountApiV1}/pt-completo/${id}`);
        }
    }
    // Servidor de Relatórios
    getAcompanharSPVs(data) {
        return this.http.post(`${SCAMP_API_RPT.accountApiV1}/spv-pesquisar-por-periodo`, data);
    }
}
SpvService.ngInjectableDef = i0.defineInjectable({ factory: function SpvService_Factory() { return new SpvService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: SpvService, providedIn: "root" });
